<template>
  <div v-bind:class="{'header':true, 'wrapper': true, 'headerStaging':(headerClass == '1production')}">
    <AdditionalAccount />
      <el-alert
        v-if="headerClass != 'production'"
        title="This is staging"
        type="error">
      </el-alert><br/>
    <UiToastList/>
    
    <div v-if="$isLoggedIn" class="menu-wrapper">

      <ul class="menu">
        <li>
          <router-link :to="{ name: 'projects', query: projectsQuery }">Projects</router-link>
        </li>
      </ul>
      <el-dropdown>
        <el-tooltip class="item" effect="dark" :content="getEmail()" placement="left-start">
          <el-button icon="el-icon-user" type="primary">
            {{getLogin()}}<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>      
        </el-tooltip>
      
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <span class="logout-button" @click="goProfile()">Profile</span>
          
        </el-dropdown-item>
        <el-dropdown-item>
          <span class="logout-button" @click="additional()">Log into another account</span>
        </el-dropdown-item>
        <el-dropdown-item>
          <span class="logout-button" @click="logout()">Logout</span>
        </el-dropdown-item>
        
      </el-dropdown-menu>
    </el-dropdown>
    
    </div>
  </div>

</template>

<script>
import * as authService from '../services/auth.service'
import AdditionalAccount from './AdditionalAccount';
import UiHeaderDropdownMenu from '@/components/UiHeaderDropdownMenu.vue'
import UiToastList from '@/components/UiToastList'
import { mapState } from 'vuex';
export default {
  name: 'Header',
  components: {
    UiToastList,
    UiHeaderDropdownMenu,
    AdditionalAccount
  },
  computed: {
    ...mapState('user', {
        user: 'userModel',
        view: 'view'
      }),
    projectsQuery () {
      return ['limit', 'page', 'show_all'].reduce((query, key) => {
        if (this.$route.query[key]) {
          query[key] = this.$route.query[key]
        }

        return query
      }, {})
    }
  },
  methods: {
    additional() {
      var state = this.view;
      state.additionalDialog = true;
      this.$store.dispatch('user/setView', state);
    },
    getActiveUsers() {
      var users = [];
      users.push(this.getUserModel());
      return users;//localStorage.get('activeUsers');
    },
    getActiveUsersCount() {
      var users = this.getActiveUsers();
      return users.length;
    },
    getEmail() {
      var model = this.getUserModel();
      return (model == null) ? 'unknown: relogin, please' : model.email;
    },
    goProfile() {
      //todo go to profile
      this.$router.push({ name: 'profile' })
    },
    getLogin() {
      var model = this.getUserModel();
      return (model == null) ? 'Relogin to get a name' : model.name;
    },
    getUserModel() {
      return JSON.parse(localStorage.getItem('userData'));
    },
    logout () {
      authService.makeLogout()
    },
    getHeaderClass() {
      return process.env.NODE_ENV;
    }
  },
  data () {
    return {
      currentPage: 'index',
      headerClass: this.getHeaderClass(),
      additionalVisible:false
    }
  }
}
</script>

<style lang="scss" scoped>
.el-alert__title{
  color:grey !important;
}
#headerPlank{
  background-color: pink;
  border-radius: 5px;
  padding:10px;
}
.headerStaging{
  background-color: #ccc;
}
.el-button--danger {
  color: white !important;
}
.header {
  z-index: 1;
  padding: 20px 0;
  position: relative;

  .is-active {
    color: #e01b3c;
  }

  a {
    color: #000;
    text-decoration: none;
  }

  .menu-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .menu {
    font-size: 25px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      padding: 15px;

    }

    &.side {
      font-size: 15px;

      .logout-button {
        cursor: pointer;
      }
    }
  }
}
</style>
